import {Component, OnInit} from "@angular/core";
import {UserService} from "../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {ApiService} from "../../../services/api.service";
import {LoggedInPageBaseComponent} from "../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-consultant-select-account',
  templateUrl: './consultant-select-account.component.html',
  styleUrls: ['./consultant-select-account.component.scss'],
  standalone: false
})
export class ConsultantSelectAccountComponent extends LoggedInPageBaseComponent implements OnInit {

  breadCrumbs = [
    { label: 'Login', path: 'app/login'},
    { label: 'Select Your Account', path: 'app/consultants/users/account/selection'}
  ];
  username: string = '';
  users: any[] = [];

  showPageSubscriptionMessages: boolean = false;
  subscriptionMessages: any[] = [];

  constructor(private auth2ServiceChild: Auth2Service, private apiService: ApiService,
              private userService: UserService,
              private routerChild: Router, private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Select Your Account")
  }

  ngOnInit(): void {
    //verify subscription
    this.pageSuccessMessages = [];
    this.pageErrorMessages = [];
    //
    this.username = this.auth2ServiceChild.getUsername();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    // @ts-ignore
    this.userService.getAllUsersAssociatedWithConsultant(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.users = result.body;
      }
    }, (error: HttpErrorResponse) => {
      console.log(JSON.stringify(error))
      this.redirectToLogin(error);
      this.pageErrorMessages.push({
        field: 'Consultant Accounts error',
        detail: 'Could not pull all the consultant accounts.',
        severity: 'severity'
      });
      this.showErrorMessagesToUser();
    });
  }

  navToDashboard(userDto: any): void {
    //Record the impersonated account username in the cache if the consultant select a client account instead
    console.log("userDto.email: " + userDto.email);
    console.log("userDto.isConsultant: " + this.users[0].isConsultant);
    console.log("userDto.consultantReferralCodeVerified: " + userDto.consultantReferralCodeVerified);
    console.log("userDto.consultantRoleName: " + userDto.consultantRoleName);
    if (this.username != userDto.email &&
          this.auth2ServiceChild.getIsConsultant() == 'Y' &&
            userDto.consultantReferralCodeVerified == 'Y'
    ) {
      this.auth2ServiceChild.setImpersonatedEmail(userDto.email);
      this.auth2ServiceChild.setConsultantRoleName(userDto.consultantRoleName);
    } else {
      this.auth2ServiceChild.removeImpersonatedEmail();
      this.auth2ServiceChild.removeConsultantRoleName();
    }

    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
